import {BI_ERRORS} from './errors';
import {logError} from './logging';

export function installUnhandled() {
  const original = window['onunhandledrejection'];
  window['onunhandledrejection'] = function (...args) {
    if (original) {
      try {
        original(...args);
      } catch (ex) {
        console.error(ex);
      }
    }
    const event: PromiseRejectionEvent = args[0];
    logError(BI_ERRORS.widget.unhandled.rejection, {reason: event && event.reason ? event.reason : 'reason unknown'});
  };
}



// WEBPACK FOOTER //
// ./logging/unhandled.ts